<template>
  <Row
    type="flex"
    justify="center"
    align="middle"
    class="login"
    @keydown.enter.native="submitLogin"
  >
    <Col :xs="{span:22}" style="width: 368px;">
      <Row class="header">
        <img src="../assets/images/login-logo.png" width="220px" />
        <div class="description">网校标品</div>
      </Row>
      <div class="major">欢迎使用后台管理系统</div>
      <Row class="login-form">
        <Form ref="loginForm" :model="form" :rules="rules" class="form">
          <FormItem prop="username">
            <Input
              v-model="form.username"
              prefix="ios-contact"
              size="large"
              clearable
              placeholder="请输入账号"
              autocomplete="off"
            />
          </FormItem>
          <FormItem prop="password">
            <Input
              type="password"
              v-model="form.password"
              prefix="ios-lock"
              size="large"
              clearable
              placeholder="请输入密码"
              autocomplete="off"
            />
          </FormItem>
        </Form>
        <Row>
          <Button
            class="login-btn"
            type="primary"
            size="large"
            :loading="loading"
            @click="submitLogin"
            long
          >
            <span v-if="!loading">登录</span>
            <span v-else>登录中...</span>
          </Button>
        </Row>
      </Row>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      form: {
        username: "admin",
        password: ""
      },
      rules: {
        username: [
          {
            required: true,
            message: "账号不能为空"
          }
        ],
        password: [
          {
            required: true,
            message: "密码不能为空"
          }
        ]
      }
    };
  },
  methods: {
    submitLogin() {
      this.$refs["loginForm"].validate(async valid => {
        if (!valid) return;
        let data = await this.$http.post("/api/adminUser/login", {
          mobile: this.form.username,
          password: this.form.password
        });
        this.$store.commit("login", data);
        this.$Message.success("登录成功");
        this.$router.push({ name: "Main" });
      });
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.login {
  height: 100vh;
  background: url("../assets/images/login_bg.png");
  background-size: 100% 100%;
  .header {
    margin-bottom: 3vh;
    text-align: center;
    .description {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      margin-top: 1vh;
    }
  }
  .major {
    font-size: 20px;
    margin-bottom: 20px;
    text-align: center;
    color: #2d8cf0;
  }
  .login-form {
    margin-bottom: 16vh;
  }
  .ivu-tabs-nav-container {
    line-height: 2;
    font-size: 17px;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    zoom: 1;
  }
  .form {
    padding-top: 1vh;
    .input-verify {
      width: 70%;
    }
    .count-verify,
    .send-verify {
      width: 100px;
    }
  }
  .forget-pass,
  .other-way {
    font-size: 14px;
  }
  .login-btn,
  .other-login {
    margin-top: 3vh;
  }
  .icons {
    display: flex;
    align-items: center;
  }
  .other-icon {
    cursor: pointer;
    margin-left: 10px;
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.2);
    :hover {
      color: #2d8cf0;
    }
  }
  .foot {
    margin-bottom: 2vh;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    .help {
      margin: 0 auto 1vh;
      width: 60%;
      .item {
        color: rgba(0, 0, 0, 0.45);
      }
      :hover {
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}

.ivu-tabs-nav .ivu-tabs-tab .ivu-icon {
  width: 14px;
  height: 14px;
  margin-right: 8px;
  margin-bottom: 5px;
}
</style>
